import * as utils from '../../../core/utils/utils'

export class Expedition {
  /** Internal batch number */
  internalBatchNumber: string

  /** OF number */
  workOrder: String

  /** OF type */
  workOrderType: string

  /** Site code */
  site: string

  /** Supplier name */
  supplierName: string

  /** Expedition date */
  expeditionDate: string
  get expeditionDateAsDate(): Date {
    return utils.strDateToDate(this.expeditionDate)
  }

  /** Pallet */
  palletId: string

  /** Quantity */
  palletQuantity: { value: string; unit: string }

  /** Stocking pallet */
  stockPalletId: string

  /** Stocking pallet quantity */
  stockPalletQuantity: { value: string; unit: string }

  constructor(expedition: Partial<Expedition>) {
    this.internalBatchNumber = expedition.internalBatchNumber || ''
    this.site = expedition.site || ''
    this.workOrder = expedition.workOrder || ''
    this.workOrderType = expedition.workOrderType || ''
    this.supplierName = expedition.supplierName || ''
    this.expeditionDate = expedition.expeditionDate || ''
    this.palletId = expedition.palletId || ''
    this.palletQuantity = expedition.palletQuantity || { value: '', unit: '' }
    this.stockPalletId = expedition.stockPalletId || ''
    this.stockPalletQuantity = expedition.stockPalletQuantity || {
      value: '',
      unit: ''
    }
  }
}
